export const createAndResizeCircImgDivs = (parentElement = document) => {
    const images = parentElement.querySelectorAll('.circ-img');
    images.forEach(function(img) {
        if (!img.nextElementSibling || !img.nextElementSibling.classList.contains('circ-img-div')) {
            const div = document.createElement('div');
            div.className = 'circ-img-div';
            div.style.backgroundImage = `url('${img.src}')`;
            img.after(div);
        }
    });

    const resizeHandler = () => {
        parentElement.querySelectorAll('.circ-img-div').forEach((div) => {
            div.style.height = `${div.offsetWidth}px`;
        });
    };

    window.addEventListener('resize', resizeHandler);
    resizeHandler(); // Set initial size
    return () => window.removeEventListener('resize', resizeHandler);
};

export const createAndResizeRectImgDivs = (parentElement = document) => {
    const images = parentElement.querySelectorAll('.rect-img');
    images.forEach(function(img) {
        if (!img.nextElementSibling || !img.nextElementSibling.classList.contains('rect-img-div')) {
            const div = document.createElement('div');
            div.className = 'rect-img-div';
            div.style.backgroundImage = `url('${img.src}')`;
            img.after(div);
        }
    });
};